import { ITextFieldProps, TextField } from '@amagimedia/amagi-design-system';
import { useField } from 'formik';
import { FocusEventHandler, FunctionComponent } from 'react';

interface IProps extends ITextFieldProps {
  name: string;
}

export const FormikTextField: FunctionComponent<IProps> = (props) => {
  const [field, meta, helpers] = useField(props.name);
  const errorMessage = meta.touched ? meta.error : '';

  const handleBlur: FocusEventHandler<HTMLInputElement> = (e) => {
    const value = e.target.value.trim();
    helpers.setValue(value);
    field.onBlur(e);
  };

  return (
    <TextField
      id={field.name}
      value={field.value}
      onChange={field.onChange}
      errorMessage={errorMessage}
      onBlur={handleBlur}
      {...props}
      data-testid={`text-field-${field.name}`}
    />
  );
};
